import type { RouteObject, LoaderFunction } from 'react-router-dom';

type CustomRouteObject = {
  help?: {
    /** 系统操作指南 */
    systemGuide: string,
    /** 常见问题 */
    commonProblem: string,
  };
  /** 隐藏 ContentHead */
  hideContentHead?: Boolean,
  /** 隐藏 ContentFooter */
  hideContentFooter?: Boolean,
  component?: LoaderFunction;
  name?: string;
  children?: CustomRouteObject[];
} & RouteObject;

export default [
  {
    name: '首页',
    component: window.__MICRO_APP_ENVIRONMENT__
      ? () => import('@/components/Layouts/MicroLayout')
      : () => import('@/components/Layouts/PageLayout2'),
    children: [
      {
        path: '/',
        name: '首页',
        hideContentHead: true,
        component: () => import('@/pages/home/index'),
        children: [
          {
            path: '/Index/index/*',
            name: '首页',
            hideContentHead: true,
            component: () => import('@/pages/home/index'),
          },
        ]
      },
      {
        path: '/UserCenter/userinfo/*',
        name: '首页',
        component: () => import('@/pages/UserCenter/userinfo'),
      },
      {
        path: '/BillConsignee/*',
        name: '提单收/发货人配置',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/BillConsignee'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/VATPriority/*',
        name: 'VAT优先级配置',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/VATPriority'),
      },
      {
        path: '/InventorySynchronizationRule/index/*',
        name: '库存同步规则',
        component: () => import('@/pages/InventorySynchronizationRule/index'),
        help: {},
      },
      {
        path: '/InventorySynchronizationRule/add/*',
        name: '新增规则',
        component: () => import('@/pages/InventorySynchronizationRule/info'),
        help: {},
      },
      {
        path: '/InventorySynchronizationRule/edit/*',
        name: '修改规则',
        component: () => import('@/pages/InventorySynchronizationRule/info'),
        help: {},
      },
      {
        path: '/InventorySynchronizationRule/details/*',
        name: '规则详情',
        component: () => import('@/pages/InventorySynchronizationRule/details'),
        help: {},
      },
      {
        path: '/CustomerPerformanceReportQueryPath/index/*',
        name: '客户履约报告查询',
        component: () => import('@/pages/CustomerPerformanceReportQueryPath/index'),
        help: {},
      },
      {
        path: '/CustomerPerformanceReportQueryPath/detail/*',
        name: '库存分析报告',
        component: () => import('@/pages/InventoryAnalysisReport/index'),
        help: {},
      },
      {
        path: '/CustomerPerformanceReportQueryPath/quality/*',
        name: '质量报告',
        component: () => import('@/pages/QualityReport/index'),
        help: {},
      },
      {
        path: '/Address',
        name: '地址管理',
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
        children: [
          {
            index: true,
            name: '地址管理',
            path: '*',
            component: () => import('@/pages/PersonalCenter/ServiceSettings/Address'),
          },
          {
            path: 'ispRecommend/*',
            name: '地址管理-ISP退件地址',
            component: () => import('@/pages/PersonalCenter/ServiceSettings/Address'),
          },
        ]
      },
      {
        path: '/ShipperAddress/index/*',
        name: '地址管理-FBA收货地址',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Address'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/ReturnAddress/index/*',
        name: '地址管理-退货地址',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Address'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/ExportCenter/index/*',
        name: '导出中心',
        component: () => import('@/pages/PersonalCenter/DownloadCenter/ExportCenter/index'),
      },
      {
        path: 'Experience/standardScheme/*',
        name: '海外仓业务激励方案',
        component: () => import('@/pages/PersonalCenter/CouponsDiscounts/Experience/standardScheme'),
      },
      {
        path: 'GiftCard/giftCardManagement/*',
        name: '礼品卡管理',
        component: () => import('@/pages/PersonalCenter/CouponsDiscounts/GiftCard/GiftCardManagement'),
      },
      {
        path: '/IorEor/index/*',
        name: '进/出口商管理',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/IorEor'),
      },
      {
        path: '/UserCenter/preferences',
        name: '偏好设置',
        help: {},
        children: [
          {
            index: true,
            name: '地址管理',
            path: '*',
            component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences'),
          },
        ]
      },
      {
        path: '/UserCenter/intelligentCreate/*',
        name: '新增仓组',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/intelligentCreate'),
      },
      {
        path: '/UserCenter/intelligentUpdate/*',
        name: '编辑仓组',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/intelligentCreate'),
      },
      {
        path: '/UserCenter/intelligentView/*',
        name: '查看仓组',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/intelligentCreate'),
      },
      {
        path: '/Address/autoCorrection/*',
        name: '地址自动修正配置',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Address/autoCorrection'),
      },
      {
        path: '/UserCenter/declareValueGetSetting/*',
        name: '申报价值获取设置',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/DeclareValueGetSettings'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/EbayCertifiedSku/*',
        name: 'ebay 认证仓商品推送',
        component: () => import('@/pages/GFS/CommodityAndInventory/EbayCertifiedSku'),
      },
      {
        path: '/EbayCertifiedSku/create/*',
        name: 'ebay 认证仓商品绑定',
        component: () => import('@/pages/GFS/CommodityAndInventory/EbayCertifiedSku/create'),
      },
      {
        path: '/WHOutbound/index/*',
        name: '全部订单',
        component: () => import('@/pages/WHOutbound/index'),
      },
      {
        path: '/WHOutbound/orderDetail/*',
        name: '订单详情',
        component: () => import('@/pages/WHOutbound/detail'),
      },
      {
        path: '/WHOutbound/childrenDetail/*',
        name: '子订单详情',
        component: () => import('@/pages/WHOutbound/childrenDetail'),
      },
      {
        path: '/WHOutbound/batchResult/*',
        name: '批量处理结果',
        component: () => import('@/pages/WHOutbound/batchResult'),
      },
      {
        path: '/WHOutbound/priceTools/*',
        name: '费用计算器',
        component: () => import('@/pages/WHOutbound/priceTools'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/WHOutbound/createOrder/*',
        name: '创建出库单',
        component: () => import('@/pages/WHOutbound/createOrder'),
      },
      {
        path: '/WHOutbound/orderType/*',
        name: '创建出库单',
        component: () => import('@/pages/WHOutbound/createOrder'),
      },
      {
        path: '/WHOutbound/batchImport/*',
        name: '批量上传',
        component: () => import('@/pages/WHOutbound/batchImport'),
      },
      {
        path: '/WHOutbound/intelligentRecommendedLogInfo/*',
        name: '智能推荐日志',
        component: () => import('@/pages/WHOutbound/intelligentRecommendedLogInfo'),
      },
      {
        path: '/WHOutbound/intelligentRecommendedLogDetail/*',
        name: '智能推荐日志详情',
        component: () => import('@/pages/WHOutbound/intelligentRecommendedLogDetail'),
      },
      {
        path: '/ShortOrder/index/*',
        name: '缺量订单处理',
        component: () => import('@/pages/ShortOrder/index'),
      },
      {
        path: '/MixedStorage/index/*',
        name: '指定不良品混合存储',
        component: () => import('@/pages/Return/ReturnItemManagement/MixedStorage'),
      },
      {
        path: '/MerchandiseInfo/info/*',
        name: '商品信息',
        component: () => import('@/pages/Merchandise/Info/index'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
        hideContentHead: true,
      },
      {
        path: '/MerchandiseInfo/addImportCountry/*',
        name: '批量新增进口国',
        component: () => import('@/pages/Merchandise/Info/addImportCountry'),
        hideContentHead: true,
      },
      {
        path: '/EuProxy/index/*',
        name: 'GPSR信息维护',
        component: () => import('@/pages/Merchandise/EuProxy/index'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/EuProxy/deManual/*',
        name: '德语说明书管理',
        component: () => import('@/pages/Merchandise/EuProxy/deManual'),
        help: {
          systemGuide: '1679112149abd917cdb882d431eaa20e',
          commonProblem: '16904c298c68cc51d8926b24d9fae7ff'
        },
      },
      {
        path: '/MerchandiseInfo/batchAdd/*',
        name: '注册商品',
        component: () => import('@/pages/Merchandise/Register/index'),
        hideContentHead: true,
      },
      {
        path: '/MerchandiseInfo/detail/*',
        name: '商品详情',
        component: () => import('@/pages/Merchandise/Register/Detail'),
        hideContentHead: true,
      },
      {
        path: '/MerchandiseInfo/edit/*',
        name: '商品编辑',
        component: () => import('@/pages/Merchandise/Register/Edit'),
        hideContentHead: true,
      },
      {
        path: '/MerchandiseInfo/add/*',
        name: '新增商品',
        component: () => import('@/pages/Merchandise/Register/SingleAdd'),
        hideContentHead: true,
      },
      {
        path: '/MerchandiseInfo/sub/*',//创建箱/套装产品
        name: '创建产品',
        component: () => import('@/pages/Merchandise/Register/Boxproduct'),
        hideContentHead: true,
      },
      {
        path: '/Australia/index/*',
        name: '海外仓库存',
        component: () => import('@/pages/Inventory/Australia/index'),
      },
      {
        path: '/CargoTransfer/index/*',
        name: '货权转移列表',
        component: () => import('@/pages/Inventory/CargoTransfer/index'),
      },
      {
        path: '/CargoTransfer/detail/*',
        name: '查看明细',
        component: () => import('@/pages/Inventory/CargoTransfer/detail'),
      },
      {
        path: '/OwnerStockQuery/index/*',
        name: 'Owner库存查询',
        component: () => import('@/pages/OwnerStockQuery/index'),
      },
      {
        path: '/TransactionDetails/index/*',
        name: 'Owner交易明细',
        component: () => import('@/pages/TransactionDetails/index'),
      },
      {
        path: '/InitializeIibraryInventory/index/*',
        name: '在库库存初始化',
        component: () => import('@/pages/InitializeIibraryInventory/index'),
      },
      {
        path: '/Australia/AutoZeroingStrategy',
        name: '共享箱/套装产品自动拆零策略',
        component: () => import('@/pages/Inventory/Australia//AutoZeroingStrategy/index'),
      },
      {
        path: '/AbnormalInventoryDetails/index/*',
        name: '异常库存明细',
        component: () => import('@/pages/Inventory/AbnormalInventoryDetails/index'),
      },
      {
        path: '/InvalidInventory/index/*',
        name: 'VAT失效禁售库存明细',
        component: ()=> import('@/pages/Inventory/InvalidInventory/index')
      },
      {
        path: '/AbnormalModificationInventory/index/*',
        name: '异动库存确认',
        component: () => import('@/pages/Inventory/AbnormalModificationInventory/index'),
      },
      {
        path: '/QueryTtemBarcode/index/*',
        name: '单品条码查询',
        component: () => import('@/pages/Inventory/QueryTtemBarcode/index'),
      },
      {
        path: '/ImportTtemBarcode/index/*',
        name: '单品条码导入',
        component: () => import('@/pages/Inventory/ImportTtemBarcode/index'),
      },
      {
        path: '/InboundOntime/index/*',
        name: '入库及时率',
        hideContentHead: true,
        component: () => import('@/pages/Fulfillment/StatisticsTool/InboundOntime'),
      },
      {
        path: '/OutboundOnTime/index/*',
        name: '出库及时率',
        hideContentHead: true,
        component: () => import('@/pages/Fulfillment/StatisticsTool/OutboundOnTime'),
      },
      {
        path: '/WarehouseAllocationIndicator/index/*',
        name: '仓配指标',
        hideContentHead: true,
        component: () => import('@/pages/Fulfillment/StatisticsTool/WarehouseAllocationIndicator'),
      },
      {
        path: '/WarehouseOrder/priceBlock/*',
        name: '价卡查询',
        hideContentHead: true,
        component: () => import('@/pages/PriceBlock/index'),
      },
      {
        path: '/QueryPostCode/index/*',
        name: '邮编查询工具',
        hideContentHead: true,
        component: () => import('@/pages/Fulfillment/StatisticsTool/QueryPostCode'),
      },
      {
        path: '/EcommerceCalculator/index/*',
        name: '电商清关计算器',
        hideContentHead: true,
        component: () => import('@/pages/Fulfillment/StatisticsTool/EcommerceCalculator'),
      },
      {
        path: '/AccountGroup/walletOverview/*',
        name: '账单总览',
        component: () => import('@/pages/AccountGroup/index'),
      },
      {
        path: '/OnlineRechargeNew/index/*',
        name: '付款',
        component: () => import('@/pages/OnlineRechargeNew/index'),
      },
      {
        path: '/paymentResult/index/*',
        name: '付款结果',
        component: () => import('@/pages/PaymentResult/index'),
      },
      {
        path: '/LineAccount/OWHSIndex',
        name: '账单总览',
        component: () => import('@/pages/AccountGroup/index'),
      },
      {
        path: '/LineAccount/ISPIndex',
        name: '账单总览',
        component: () => import('@/pages/AccountGroup/index'),
      },
      {
        path: '/LineAccount/quotaDetail/*',
        name: '授信额度详情',
        component: () => import('@/pages/QuotaDetail/index'),
      },
      {
        path: '/LineAccount/tempQuotaDetail/*',
        name: '头程临时额度详情',
        component: () => import('@/pages/TempQuotaDetail/index'),
      },
      {
        path: '/LineAccount/guaranteeQuotaDetail/*',
        name: '已担保还款金额详情',
        component: () => import('@/pages/GuaranteeQuotaDetail/index'),
      },
      {
        path: '/Wallet/freezeDetailCredit/*',
        name: '已担保还款金额详情',
        component: () => import('@/pages/FreezeDetailCredit/index'),
      },
      {
        path: '/AccountGroup/quotaAllocation/*',
        name: '额度分配',
        component: () => import('@/pages/QuotaAllocation/index'),
      },
      {
        path: '/RechargeNew/edit/*',
        name: '编辑',
        component: () => import('@/pages/OnlineRechargeNew/index'),
      },
      {
        path: '/OverseasOrder/indexNew/*',
        name: '业务收费单',
        component: () => import('@/pages/OverseasOrder/index'),
      },
      {
        path: '/DownloadStatementNew/index/*',
        name: '对账单',
        component: () => import('@/pages/DownloadStatementNew/index'),
      },
      {
        path: '/PaidBill/index/*',
        name: '已还明细',
        component: () => import('@/pages/PaidBill/index'),
      },
      {
        path: '/Wallet/deductions/*',
        name: '交易流水',
        component: () => import('@/pages/TradingStatement/index'),
      },
      {
        path: '/PurchaseRecord/index/*',
        name: '购汇记录',
        component: () => import('@/pages/PurchaseRecord/index'),
      },
      {
        path: '/AccountGroup/Personalization/*',
        name: '个性化设置',
        component: () => import('@/pages/Personalization/index'),
      },
      {
        path: '/RechargeNew/index/*',
        name: '付款单',
        component: () => import('@/pages/RechargeNew/index'),
      },
      {
        path: '/PaymentStatement/index/*',
        name: '付款人管理',
        component: () => import('@/pages/PaymentStatement/index'),
      },
      {
        path: '/FileManagement/index/*',
        name: '文件管理',
        hideContentHead: true,
        component: () => import('@/pages/Merchandise/FileManagement/index'),
      },
      {
        path: '/WHInbound/info/*',
        name: '全部订单',
        hideContentHead: true,
        component: () => import('@/pages/WHInbound/index'),
      },
      {
        path: '/WHInbound/createOrder/*',
        name: '新增入库单',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/createOrder'),
      },
      {
        path: '/WHInbound/editOrder/*',
        name: '编辑入库单',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/createOrder'),
      },
      {
        path: '/WHInbound/orderDetail/*',
        name: '入库单详情',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/orderDetail'),
      },
      {
        path: '/WHInbound/viewMap/*',
        name: '查看头程物流跟踪',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/components/OrderList/components/ViewMap/index'),
      },
      {
        path: '/BookingOrder/index/*',
        name: '预约单管理',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/BookingOrder/index'),
      },
      {
        path: '/BookingOrder/thirdParty/*',
        name: '第三方预约单管理',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/BookingOrder/thirdParty'),
      },
      {
        path: '/BookingOrder/thirdPartyDetail/*',
        name: '第三方预约单管理详情',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/BookingOrder/thirdPartyDetail'),
      },
      {
        path: '/ExpressOrder/index/*',
        name: '快递卸货记录查询',
        component: () => import('@/pages/WHInbound/expressOrder'),
      },
      {
        path: '/WhinboundLimit/index/*',
        name: '入库限制查询',
        component: () => import('@/pages/WHInbound/limitQuery'),
      },
      {
        path: '/WhinboundFileManage/index/*',
        name: '运输资料管理',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/transportInfoManage'),
      },
      {
        path: '/WhinboundFileManage/detail/*',
        name: '运输资料管理详情',
        hideContentHead: true,
        hideContentFooter: true,
        component: () => import('@/pages/WHInbound/components/TransportInfoManage/TransportInfo/detail'),
      },
      {
        path: '/UserCenter/preferences/modify/*',
        name: '新增/编辑入库偏好',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/modify'),
        help: {},
      },
      {
        path: '/InsuranceOrderManage/index/*',
        name: '投保订单管理',
        component: () => import('@/pages/InsuranceOrderManage/index'),
        help: {},
      },
      {
        path: '/InsuranceOrderManage/detail/*',
        name: '投保订单详情',
        component: () => import('@/pages/InsuranceOrderManage/detail'),
        help: {},
      },
      {
        path: '/TransferGoods/index/*',
        name: '全部货权转移订单',
        component: () => import('@/pages/TransferGoods/index'),
        help: {},
      },
      {
        path: '/TransferGoods/detail/*',
        name: '货权转移订单详情',
        component: () => import('@/pages/TransferGoods/detail'),
        help: {},
      },
      {
        path: '/AllWarehouseOrders/info/*',
        name: '全部库内订单',
        component: () => import('@/pages/AllWarehouseOrders/info'),
        help: {},
      },
      {
        path: '/InventoryTypeAdjustment/index/*',
        name: '全部分类库存调整单',
        component: () => import('@/pages/InventoryTypeAdjustment/index'),
        help: {},
      },
      {
        path: '/InventoryTypeAdjustment/detail/*',
        name: '分类库存调整单详情',
        component: () => import('@/pages/InventoryTypeAdjustment/detail'),
        help: {},
      },
      {
        path: '/AllWarehouseOrders/orderDetail/*',
        name: '库内订单详情',
        component: () => import('@/pages/AllWarehouseOrders/orderDetail'),
        help: {},
      },
      {
        path: '/ChildAccount/logList/*',
        name: '账号登录日志',
        component: () => import('@/pages/ChildAccount/index'),
        help: {},
      },
      {
        path: '/ChildAccount/roleList/*',
        name: '账号登录日志',
        component: () => import('@/pages/ChildAccount/roleList'),
        help: {},
      },
      {
        path: '/ChildAccount/accountList/*',
        name: '子账号管理',
        component: () => import('@/pages/ChildAccount/account'),
        help: {},
      },
      {
        path: '/SystemNotify/index/*',
        name: '系统公告',
        component: () => import('@/pages/SystemNotify/index'),
        help: {},
      },
      {
        path: '/SystemNotify/view/*',
        name: '系统公告',
        component: () => import('@/pages/SystemNotify/systemNoticeDetail'),
        help: {},
      },
      {
        path: '/SystemNotify/notificationMsg/*',
        name: '通知消息',
        component: () => import('@/pages/SystemNotify/notificationInfo'),
        help: {},
      },
      {
        path: '/MessageSubscription/addSubscription/*',
        name: '新增订阅',
        component: () => import('@/pages/UserCenter/MessageSubscription/addSubscription'),
        help: {},
      },
      {
        path: '/MessageSubscription/editSubscription/*',
        name: '编辑订阅',
        component: () => import('@/pages/UserCenter/MessageSubscription/addSubscription'),
        help: {},
      },
      {
        path: '/MessageSubscription/subscriptionManage/*',
        name: '订阅管理',
        component: () => import('@/pages/UserCenter/MessageSubscription/index'),
        help: {},
      },
      {
        path: '/VasOrder',
        name: '增值订单',
        children: [
          {
            index: true,
            name: '增值订单',
            path: '*',
            // component: () => import('@/pages/PersonalCenter/ServiceSettings/Address'),
          },
          {
            path: 'createOrder/*',
            name: '创建增值订单',
            component: () => import('@/pages/VasOrder/createOrder'),
          },
          {
            path: 'createInstockOrder/*',
            name: '创建库内增值订单',
            component: () => import('@/pages/VasOrder/createOrder'),
          },
          {
            path: 'info/*',
            name: '全部增值订单',
            component: () => import('@/pages/VasOrder/info'),
          },
          {
            path: 'orderDetail/*',
            name: '增值订单详情',
            component: () => import('@/pages/VasOrder/orderDetail'),
          },
        ]
      },
      {
        path: '/DepositFreezeManagement/index/*',
        name: 'PVA押金冻结管理',
        component: () => import('@/pages/DepositFreezeManagement/index'),
      },
      {
        path: '/InboundDetailsTracking/index/*',
        name: 'PVA入库明细跟踪',
        component: () => import('@/pages/InboundDetailsTracking/index'),
      },
      {
        path: '/OrgInventory/index/*',
        name: '组织库存',
        component: () => import('@/pages/OrgInventoryManage/OrgInventory/index'),
      },
      {
        path: '/OrgInventory/changeRecord/*',
        name: '组织库存变更记录',
        component: () => import('@/pages/OrgInventoryManage/OrgInventoryChange/index'),
      },
      {
        path: '/OrgInventory/adjust/*',
        name: '组织库存调整',
        component: () => import('@/pages/OrgInventoryManage/OrgInventoryAdjust/index'),
      },
      {
        path: '/OrgInventory/createAdjustOrder/*',
        name: '创建组织库存调整单',
        component: () => import('@/pages/OrgInventoryManage/OrgInventoryAdjust/CreateAdjustOrder'),
      },
      {
        path: '/OrgInventory/organization/*',
        name: '组织管理',
        component: () => import('@/pages/OrgInventoryManage/OrgManagement/index'),
      },
      {
        path: '/OrgInventory/strategy/*',
        name: '分配策略',
        component: () => import('@/pages/OrgInventoryManage/AllocationStrategy/index'),
      },
      {
        path: '/OrgInventory/init/*',
        name: '组织库存初始化',
        component: () => import('@/pages/OrgInventoryManage/OrgInventoryInit/index'),
      },
      {
        path: '/InventoryLockConfig/index/*',
        name: 'AliExpress海外托管专享库存',
        component: () => import('@/pages/GFS/CommodityAndInventory/InventoryLockConfig/index'),
      },
      {
        path: '/StockConfig/index/*',
        name: '组织库存初始化',
        component: () => import('@/pages/StockConfig/index'),
      },
      {
        path: '/UserCenter/site/*',
        name: '账号安全',
        component: () => import('@/pages/UserCenter/site'),
      },
      {
        path: '/Index/account/*',
        name: '修改邮箱',
        component: () => import('@/pages/UserCenter/account'),
      },
      {
        path: '/UserCenter/phoneModify/*',
        name: '修改手机账号',
        component: () => import('@/pages/UserCenter/phoneModify'),
      },
      {
        path: '/UserCenter/wechatBind/*',
        name: '绑定微信',
        component: () => import('@/pages/UserCenter/wechatBind'),
      },
      {
        path: '/BatchPrintBarcodes/index/*',
        name: '批量打印条码',
        component: () => import('@/pages/Merchandise/BatchPrintBarcodes/index'),
      },
      {
        path: '/PackageManagement/index/*',
        name: '组套商品关系管理',
        component: () => import('@/pages/Merchandise/PackageManagement/index'),
      },
      {
        path: '/PackageManagement/addGroupSuit/*',
        name: '新增组套',
        component: () => import('@/pages/Merchandise/PackageManagement/components/GroupSuitTab/detail'),
      },
      {
        path: '/PackageManagement/editGroupSuit/*',
        name: '编辑组套',
        component: () => import('@/pages/Merchandise/PackageManagement/components/GroupSuitTab/detail'),
      },
      {
        path: '/PackageManagement/detail/*',
        name: '组套详情',
        component: () => import('@/pages/Merchandise/PackageManagement/components/GroupSuitTab/detail'),
      },
      {
        path: '/InsuranceSkuManage/index/*',
        name: '投保商品管理',
        component: () => import('@/pages/Merchandise/InsuranceSkuManage/index'),
      }, {
        path: '/Australia/batchInventory/*',
        name: '分类库存',
        component: () => import('@/pages/Inventory/BatchInventory/index'),
      },
      {
        path: '/Australia/inventoryFlow/*',
        name: '库存流水',
        component: () => import('@/pages/Inventory/InventoryFlow'),
      },
      {
        path: '/Australia/libraryAgeAnalysis/*',
        name: '库龄分析明细',
        component: () => import('@/pages/Inventory/LibraryAgeAnalysis'),
      },
      {
        path: '/StorageTollList/index/*',
        name: '仓储单',
        component: () => import('@/pages/Inventory/StorageTollList'),
      },
      {
        path: '/StorageTollListDetail/index/*',
        name: '仓储单明细',
        component: () => import('@/pages/StorageOrderDetail'),
      },
      {
        path: '/PickupDetail/index/*',
        name: '出库自提仓租单明细',
        component: () => import('@/pages/StorageOrderDetail'),
      },
      {
        path: '/EbayAccount/*',
        name: '店铺授权',
        component: () => import('@/pages/GFS/EbayAccount'),
      },
      {
        path: '/AutoRulesSetting/index/*',
        name: '自动发货规则',
        component: () => import('@/pages/GFS/AutoRulesSetting/index'),
      },
      {
        path: '/AutoRulesSetting/detail/*',
        name: '新增/编辑自动发货规则',
        component: () => import('@/pages/GFS/AutoRulesSetting/detail'),
      },
      {
        path: '/AutoReturnRule/index/*',
        name: '自动退货规则',
        component: () => import('@/pages/GFS/AutoReturnRule/index'),
      },
      {
        path: '/AutoReturnRule/detail/*',
        name: '新增/编辑自动退货规则',
        component: () => import('@/pages/GFS/AutoReturnRule/detail'),
      },
      {
        path: '/SynSwitch/index/*',
        name: '订单处理规则',
        component: () => import('@/pages/GFS/SynSwitch/index'),
      },
      {
        path: '/ShippingOrder/index/*',
        name: '发货订单',
        component: () => import('@/pages/GFS/ShippingOrder/index'),
      },
      {
        path: '/ShippingOrder/edit/*',
        name: '发货订单编辑',
        component: () => import('@/pages/GFS/ShippingOrder/Edit/index'),
      },
      {
        path: '/ShippingOrder/detail/*',
        name: '发货订单详情',
        component: () => import('@/pages/GFS/ShippingOrder/Detail/index'),
      },
      {
        path: '/OrderStatistics/index/*',
        name: '订单统计',
        component: () => import('@/pages/OrderStatistics/index'),
      },
      {
        path: '/ReturnOrders/quickReturn/*',
        name: '快速退货',
        component: () => import('@/pages/Return/ReturnOrders/quickReturn'),
      },
      {
        path: '/ReturnOrders/stepOneNewWH/*',
        name: '创建退货单',
        component: () => import('@/pages/Return/ReturnOrders/createOrder'),
      },
      {
        path: '/ReturnOrders/batchImport/*',
        name: '批量创建退货单',
        component: () => import('@/pages/Return/ReturnOrders/batchImport'),
      },
      {
        path: '/ReturnOrders/index/*',
        name: '退货全部订单',
        component: () => import('@/pages/Return/ReturnOrders/index'),
      },
      {
        path: '/ReturnOrders/detail/*',
        name: '退货订单详情',
        component: () => import('@/pages/Return/ReturnOrders/detail'),
      },
      {
        path: '/ReturnOrders/returnSkuProcess/*',
        name: '退货暂存处理',
        component: () => import('@/pages/Return/ReturnOrders/returnSkuProcess'),
      },
      {
        path: '/ReturnOrders/queryTracking/*',
        name: '退货轨迹查询',
        component: () => import('@/pages/Return/ReturnOrders/queryTracking'),
      },
      {
        path: '*',
        component: window.__MICRO_APP_ENVIRONMENT__
          ? () => import('@/MicroAppLoading')
          : () => import('@/components/StatusPage/NotFound'),
      },
      {
        path: '/FinalMileException/index/*',
        name: '尾程异常明细表',
        component: () => import('@/pages/FinalMileException/index'),
      },
      {
        path: '/ProductMatch/index/*',
        name: '商品匹配',
        component: () => import('@/pages/ProductMatch/index'),
      },
      {
        path: '/OrderLogisticsReturn/index/*',
        name: '退货订单',
        component: () => import('@/pages/GFS/OrderLogisticsReturn/index'),
      },
      {
        path: '/OrderLogisticsReturn/detail/*',
        name: '退货订单详情',
        component: () => import('@/pages/GFS/OrderLogisticsReturn/detail'),
      },
      {
        path: '/OrderLogisticsReturn/order/*',
        name: '下退货订单',
        component: () => import('@/pages/GFS/OrderLogisticsReturn/order'),
      },
      {
        path: '/OrderQuery/index/*',
        name: 'ebay订单查询',
        component: () => import('@/pages/GFS/OrderQuery/index'),
      },
      {
        path: '/WinitCheckQuality/index/*',
        name: '检查上架标准维护',
        component: () => import('@/pages/Return/WinitCheckQuality/index'),
      },
      {
        path: '/ReturnPhotographTemplate/index/*',
        name: '定制拍照模板维护',
        component: () => import('@/pages/Return/ReturnPhotographTemplate/index'),
      },
      {
        path: '/ReturnPolicyMaintenance/index/*',
        name: '退货策略维护',
        component: () => import('@/pages/Return/ReturnPolicyMaintenance/index'),
      },
      {
        path: '/UserCenter/serviceDetail/*',
        name: '合同及协议详情',
        component: () => import('@/pages/UserCenter/myService/serviceDetail'),
      },
      {
        path: '/AmazonRemovalOrder/index/*',
        name: 'Amazon移除单管理',
        component: () => import('@/pages/GFS/AmazonRemovalOrder/index'),
      },
      {
        path: '/AutomaticStorageRules/index/*',
        name: '自动入库规则',
        component: () => import('@/pages/GFS/AutomaticStorageRules/index'),
      },
      {
        path: '/AutomaticStorageRules/add/*',
        name: '新增自动入库规则',
        component: () => import('@/pages/GFS/AutomaticStorageRules/info'),
        help: {},
      },
      {
        path: '/AutomaticStorageRules/edit/*',
        name: '修改规则',
        component: () => import('@/pages/GFS/AutomaticStorageRules/info'),
        help: {},
      },
      {
        path: '/ExceptionDetails/index/*',
        name: '异常单',
        component: () => import('@/pages/ExceptionDetails/index'),
      },
      {
        path: '/ExceptionDetails/detail/*',
        name: '异常单详情',
        component: () => import('@/pages/ExceptionDetails/detail'),
      },
      {
        path: '/ExceptionDetails/processResult/*',
        name: '异常单处理结果',
        component: () => import('@/pages/ExceptionDetails/processResult'),
      },
      {
        path: '/ClaimAgent/',
        name: '代客索赔',
        children: [
          {
            index: true,
            name: '索赔单列表',
            path: '*',
            component: () => import('@/pages/Claim/Agent/index'),
          },
          {
            path: 'create/*',
            name: '创建索赔单',
            component: () => import('@/pages/Claim/Agent/create'),
          },
          {
            path: 'batchCreate/*',
            name: '批量创建索赔单',
            component: () => import('@/pages/Claim/Agent/batchCreate'),
          },
          {
            path: 'batchUploadFile/*',
            name: '批量创建索赔单',
            component: () => import('@/pages/Claim/Agent/batchUploadFile'),
          },
          {
            path: 'detail/*',
            name: '索赔单详情',
            component: () => import('@/pages/Claim/Agent/detail'),
          },
        ]
      },
      {
        path: '/ClaimStandard/',
        name: '标准索赔',
        children: [
          {
            index: true,
            name: '索赔单列表',
            path: '*',
            component: () => import('@/pages/Claim/Standard/index'),
          },
          {
            path: 'create/*',
            name: '创建索赔单',
            component: () => import('@/pages/Claim/Standard/create'),
          },
          {
            path: 'detail/*',
            name: '索赔单详情',
            component: () => import('@/pages/Claim/Standard/detail'),
          },
        ]
      },
      {
        path: '/Tracking/',
        name: '查件',
        children: [
          {
            index: true,
            name: '查件列表',
            path: '*',
            component: () => import('@/pages/Claim/Tracking/index'),
          },
          {
            path: 'create/*',
            name: '创建查件单',
            component: () => import('@/pages/Claim/Tracking/create'),
          },
          {
            path: 'detail/*',
            name: '查件单详情',
            component: () => import('@/pages/Claim/Tracking/detail'),
          },
        ]
      },
      {
        path: '/Warehouse/',
        name: '库内查询',
        children: [
          {
            index: true,
            name: '视频查询',
            path: 'video/*',
            component: () => import('@/pages/Claim/Video/index'),
          }
        ]
      },
      {
        path: '/AmazonFBAReturnOrder/index/*',
        name: 'Amazon FBA退货单管理',
        component: () => import('@/pages/GFS/AmazonFBAReturnOrder/index'),
      },
      {
        path: '/WEEEInformation/weeeInfo/*',
        name: 'WEEE信息维护',
        hideContentHead: true,
        component: () => import('@/pages/Merchandise/WEEEInformation/WeeeInfo'),
      },
      {
        path: '/WEEEInformation/skuInfo/*',
        name: 'WEEE关联',
        hideContentHead: true,
        component: () => import('@/pages/Merchandise/WEEEInformation/SkuInfo'),
      },
      {
        path: '/TurnoverHealth/index/*',
        name: '动销健康度分析指标',
        hideContentHead: true,
        component: () => import('@/pages/DataCenter/TurnoverHealth/index'),
      },
      {
        path: '/PickupProcessing',
        name: '暂存订单处理',
        children: [
          {
            index: true,
            name: '暂存订单处理',
            path: '*',
            component: () => import('@/pages/WHOutbound/components/PickupProcessing'),
          },
          {
            path: 'editDetail/*',
            name: '暂存订单编辑',
            component: () => import('@/pages/WHOutbound/components/PickupProcessing/processDetail'),
          },
          {
            path: 'processDetail/*',
            name: '暂存订单处理',
            component: () => import('@/pages/WHOutbound/components/PickupProcessing/processDetail'),
          },
        ]
      },
      {
        path: '/WHOutbound/supplementaryInfo/*',
        name: '补充信息',
        component: () => import('@/pages/WHOutbound/supplementaryInfo'),
      },
      {
        path: '/ThirdOutbound/FailedOrder/*',
        name: '导入失败订单',
        component: () => import('@/pages/ThirdOutbound/FailedOrder'),
      },
      {
        path: '/ThirdOutbound/packageRelation/*',
        name: '大小包关系管理',
        component: () => import('@/pages/ThirdOutbound/packageRelation'),
      },
      {
        path: '/EbayEfProductManagement/index/*',
        name: 'eBay eF商品管理',
        component: () => import('@/pages/EbayEfProductManagement/index'),
      },
      {
        path: '/EbayEfProductManagement/installEf/*',
        name: '设置eBay eF服务',
        component: () => import('@/pages/EbayEfProductManagement/installEf'),
      },
      {
        path: '/WHOutbound/processOrdersInBatches/*',
        name: '分批处理订单',
        component: () => import('@/pages/WHOutbound/components/ProcessOrdersInBatches/index'),
      },
      {
        path: '/UserCenter/addPreferenceInstallEf/*',
        name: '添加eF偏好',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/preferenceInstallEf'),

      },
      {
        path: '/UserCenter/editPreferenceInstallEf/*',
        name: '修改eF偏好',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/preferenceInstallEf'),
      },
      {
        path: '/UserCenter/viewPreferenceInstallEf/*',
        name: '查看eF偏好',
        component: () => import('@/pages/PersonalCenter/ServiceSettings/Preferences/preferenceInstallEf'),
      },
      {
        path: '/SkuGroupClassManange/index/*',
        name: '商品分组管理',
        component: () => import('@/pages/Merchandise/SkuGroupClassManange/index'),
      },
      {
        path: '/QualityInspectionPlan/index/*',
        name: '质检方案维护',
        component: () => import('@/pages/Return/QualityInspectionPlan/index'),
      },
      {
        path: '/AutomaticSynchronousRules/index/*',
        name: '自动同步规则',
        component: () => import('@/pages/GFS/AutomaticSynchronousRules/index'),
      },
      {
        path: '/AutomaticSynchronousRules/add/*',
        name: '新增自动入库规则',
        component: () => import('@/pages/GFS/AutomaticSynchronousRules/info'),
        help: {},
      },
      {
        path: '/AutomaticSynchronousRules/edit/*',
        name: '修改规则',
        component: () => import('@/pages/GFS/AutomaticSynchronousRules/info'),
        help: {},
      },
      {
        path: '/LastmileDeliveryAnomaly/index/*',
        name: '尾程派送异常',
        component: () => import('@/pages/LastmileDeliveryAnomaly/index'),
        help: {},
      },
      {
        path: '/WeightChange/index/*',
        name: '尺寸重量变更重算',
        component: () => import('@/pages/Merchandise/WeightChange/index'),
      },
      {
        path: '/WeightChange/ExpenseItem/*',
        name: '尺寸重量变更重算-费用项',
        component: () => import('@/pages/Merchandise/WeightChange/ExpenseItem'),
      },
      {
        path: '/WeightChange/viewDetail/*',
        name: '尺寸重量变更重算-费用项详情',
        component: () => import('@/pages/Merchandise/WeightChange/ViewDetail'),
      },
      {
        path: '/ReportManagement/index/*',
        name: '报表管理',
        component: () => import('@/pages/ReportManagement/index'),
        help: {},
      },
      {
        path: '/WHOutbound/packageCalculate/*',
        name: '复合打包测算',
        component: () => import('@/pages/WHOutbound/packageCalculate'),
      },
      {
        path: '/SettlementProgress/index/*',
        name: '入驻进度查看',
        component: () => import('@/pages/PlatformSettled/SettlementProgress/index'),
      },
      {
        path: '/Feedback/',
        name: '反馈与建议',
        children: [
          {
            name: '功能建议',
            path: 'features/*',
            component: () => import('@/pages/Feedback/Features/index'),
          },
          {
            name: '详情',
            path: 'detail/*',
            component: () => import('@/pages/Feedback/Features/detail'),
          },
        ]
      },
    ],
  },
  {
    path: '/User/login/*',
    name: '登录页面',
    component: () => import('@/pages/User/login'),
  },
  {
    path: '/Public/register/*',
    name: '注册页面',
    component: () => import('@/pages/User/register'),
  },
  {
    path: '/Public/forgetPassword/*',
    name: '找回密码',
    component: () => import('@/pages/User/forgetPassword'),
  },
  {
    path: '/Public/resetPassword/*',
    name: '重置密码',
    component: () => import('@/pages/User/forgetPassword'),
  },
  {
    path: '/AgreementSign/index/*',
    name: '新主体供应商协议强制签署页面',
    component: () => import('@/pages/User/signGuide'),
  },
  {
    path: '/CampaignMobile/mobilePage/*',
    name: '渠道代理商线索',
    component: () => import('@/pages/User/leadForm'),
  },
  {
    path: '/Wechat/',
    name: '微信小程序引用页面',
    children: [
      {
        path: 'inventory/report/*',
        name: '库存报告详情',
        component: () => import('@/pages/Wechat/inventory/report'),
      },
    ]
  },

] as CustomRouteObject[];
